export class ChangePassword {
    public securityGuid: string;
    public password: string;
}
